import { render, staticRenderFns } from "./ShippingAdminForm.vue?vue&type=template&id=51bf333e&scoped=true&"
import script from "./ShippingAdminForm.vue?vue&type=script&lang=js&"
export * from "./ShippingAdminForm.vue?vue&type=script&lang=js&"
import style0 from "./ShippingAdminForm.vue?vue&type=style&index=0&id=51bf333e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bf333e",
  null
  
)

export default component.exports